var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestCallout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.914,
    height: 22.914,
    viewBox: "0 0 22.914 22.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_352591_msg_perm_phone_icon",
    "data-name": "352591_msg_perm_phone_icon",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25673",
    "data-name": "Path 25673",
    d: "M26.7,21.218a13.859,13.859,0,0,1-4.346-.694,1.221,1.221,0,0,0-1.236.3l-2.678,2.684a18.366,18.366,0,0,1-8.023-8.017L13.092,12.8a1.221,1.221,0,0,0,.3-1.236A13.859,13.859,0,0,1,12.7,7.217,1.213,1.213,0,0,0,11.479,6H7.217A1.217,1.217,0,0,0,6,7.217a20.7,20.7,0,0,0,20.7,20.7A1.213,1.213,0,0,0,27.914,26.7V22.436A1.213,1.213,0,0,0,26.7,21.218ZM16.957,6V18.174l3.652-3.652h7.3V6Z",
    transform: "translate(-6 -6)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestCallout);
export default __webpack_public_path__ + "static/media/request-callout.601d7d6614b549147cbd0f2121d16a0b.svg";
export { ForwardRef as ReactComponent };